import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft, ArrowDown, ChevronDown } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { overview, REVIEWED } from "@/data/destinations/overview";
import { CounselingLink } from "./GuidePrimitives";

export const CountryHero = ({ country, slug, level }) => {
  const navigate = useNavigate();
  const reducedMotion = useReducedMotion();
  return (
    <section className="guide-hero" data-testid="country-hero">
      <img src={country.image} alt={country.imageAlt} className="guide-hero-image" data-testid="country-hero-image" fetchPriority="high" />
      <div className="guide-hero-shade" />
      <div className="container-x relative z-10">
        <div className="guide-breadcrumbs">
          <Link to="/#destinations" data-testid="guide-back-destinations" className="inline-flex items-center gap-2 text-sm text-white/85 hover:text-white"><ArrowLeft size={15} />All destinations</Link>
          <div className="relative">
            <label htmlFor="guide-country-select" className="sr-only">Choose a country</label>
            <select id="guide-country-select" value={slug} onChange={(e) => navigate(`/destinations/${e.target.value}`)} data-testid="guide-country-select" className="guide-country-select">
              {Object.entries(overview).map(([key, item]) => <option key={key} value={key}>{item.name}</option>)}
            </select>
            <ChevronDown className="pointer-events-none absolute right-3 top-3.5" size={14} aria-hidden="true" />
          </div>
        </div>
        <motion.div initial={reducedMotion ? false : { opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.65 }} className="guide-hero-copy">
          <p className="guide-eyebrow mb-4">The destination edit / {country.code}</p>
          <h1 data-testid="country-heading" className="font-display text-4xl font-light leading-tight sm:text-5xl lg:text-6xl">Study in{slug === "usa" || slug === "uk" ? " the" : ""}<br />{country.name}.</h1>
          <p data-testid="country-headline" className="mt-5 max-w-xl text-lg text-white/95">{country.headline}</p>
          <div className="mt-8 flex flex-wrap items-center gap-5">
            <CounselingLink country={country} level={level} placement="hero" />
            <a href="#education" data-testid="guide-explore-link" className="inline-flex items-center gap-2 text-sm text-white hover:underline">Explore the guide <ArrowDown size={15} /></a>
          </div>
        </motion.div>
        <div className="guide-hero-meta" data-testid="guide-review-date">
          <span>Undergraduate & postgraduate</span><span>Reviewed {REVIEWED}</span>
        </div>
      </div>
    </section>
  );
};